import useApi from "../../api/useApi";

const useSpotMapService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, spotMapId) => {
    return api(
      'get',
      'user/spot_map/' + spotMapId,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotMapService::userShow: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, spotMapId, data) => {
    return api(
      'post',
      'user/spot_map/' + spotMapId + '/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotMapService::userUpdate: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, spotMapId, data) => {
    return api(
      'post',
      'user/spot_map/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotMapService::userStore: ${error?.message || JSON.stringify(error)}`)},
      data,
    )
  }

  const userDelete = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'post',
      'user/spot_map/' + id + '/delete',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useSpotMapService::userDelete: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  return {
    objectType:'spot_map',
    userShow,
    userUpdate,
    userStore,
    userDelete,
  }
}
export default useSpotMapService
